module.exports = __webpack_public_path__ + "img/KoenenDetailed-min.c43c313f.png";